import { render, staticRenderFns } from "./MCompanyEditor.yaml?vue&type=template&id=9a365e16&component"
import script from "./MCompanyEditor.yaml?vue&type=script&lang=ts&component"
export * from "./MCompanyEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports